import CheckBox from '../../../../components/CheckBox';
import { useTranslate } from '../../../../hooks/useTranslate';
import { PROHIBITIONS_KEY } from '../../constants';
import { ProhibitionsProps, ProhibitionValue } from './types';

import { HeadingWithBg } from '../../styled';
import {
  CheckBoxLabel,
  DrugsIcon,
  ExpIcon,
  FoodIcon,
  GunIcon,
  ListItem,
  ListOfProhibitions,
  MoneyIcon,
  PoisonIcon,
  Text,
} from './styled';

export default function Prohibitions({
  isProhibitionsApproval,
  setIsProhibitionsApproval,
}: ProhibitionsProps): JSX.Element {
  const { staticTranslate } = useTranslate();
  const prohibitionsValues: ProhibitionValue[] = [
    {
      image: ExpIcon,
      text: staticTranslate('ExplosiveFlammableAnd'),
    },
    {
      image: GunIcon,
      text: staticTranslate('AnyWeaponFirearmsSignal'),
    },
    {
      image: DrugsIcon,
      text: staticTranslate('DrugsPsychotropicSubstances'),
    },
    {
      image: MoneyIcon,
      text: staticTranslate('MoneyOfAnyCountry'),
    },
    {
      image: FoodIcon,
      text: staticTranslate('PerishableFoodAndBeverages'),
    },
    {
      image: PoisonIcon,
      text: staticTranslate('ThereAreAlsoHazardousItems'),
    },
  ];

  return (
    <>
      <HeadingWithBg>{staticTranslate('ProhibitedToSend')}</HeadingWithBg>
      <ListOfProhibitions aria-label="Prohibited to send">
        {prohibitionsValues.map(({ text, image: Image }) => (
          <ListItem key={text}>
            <Image />
            <Text>{text}</Text>
          </ListItem>
        ))}
      </ListOfProhibitions>
      <CheckBox
        isChecked={isProhibitionsApproval}
        onChangeState={setIsProhibitionsApproval}
        key={PROHIBITIONS_KEY}
      >
        <CheckBoxLabel>
          {staticTranslate('IDONOTSENDPROHIBITEDGOODS')}
        </CheckBoxLabel>
      </CheckBox>
    </>
  );
}
